// extracted by mini-css-extract-plugin
export default {"numberInput":"NumberInputCell_numberInput__2k4Ww"};